export default __webpack_public_path__ + "static/media/frantixmedia.f10ad06c.svg";